<template>
  <!--弹框2 英文 开始-->
  <el-dialog :visible.sync="frameNoticePublicShow" top="25vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter-en">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/notice.png" class="frame-big-img"></div>
      <div class="frame-text-hotel-sold wordBreak">
        {{$t(showNotice)}}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-goback" @click="determine">{{$t('determine')}}</el-button>
    </span>
  </el-dialog>
  <!--弹框2 英文 结束-->
  <!--引入方式-->
  <!-- <frameNoticePublic :frameNoticeDialog="frameNoticeDialog" :showNotice="showNotice"></frameNoticePublic> -->
</template>

<script>
export default {
  name: 'frameNoticeWechatPay',
  props: ['frameNoticePublicShow', 'showNotice'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  created () {},
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    determine: function () {
      this.$emit('frameNoticePublicFun', 0)
    }
  }
}
</script>

<style scoped>
.textcenter-en{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{min-height:20px; font-size: 16px;color: #4F4C4C;text-align: center;}
.dialog-goback{width: auto;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;cursor:pointer;}
.dialog-goback:hover,.dialog-goback:focus{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
.textcenter-en /deep/ .el-dialog{background-color: #fff;background-size: 23%;}
@media screen and (max-width: 1000px) {
.dialog-goback{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameNoticePublic.vue